import { useCallback } from 'react';
import useInterval from './useInterval';
import refreshTimes from '../constants/refreshTimes';

export default function useFetchIntervalData(
  callback: (manageLoader: boolean, isFromInterval?: boolean) => void,
  dataRefreshTime?: string,
) {
  const interval = refreshTimes[dataRefreshTime || 'never'];

  const refetchWidgetData = useCallback(
    (isFromInterval = false) => {
      callback(false, isFromInterval);
    },
    [callback],
  );

  useInterval(() => {
    refetchWidgetData(true);
  }, interval);

  return refetchWidgetData;
}
